import type { RelatedPlace } from "~/lib/api";
import { isMtbTrailRelatedPlace } from "~/lib/api";
import type { RelatedPlaceCategory } from "~/lib/relatedPlaces";
import { RelatedPlacesSection } from "../RelatedPlacesSection";
import { TrailsSection } from "./TrailsSection";

const NEARBY_CATEGORIES: RelatedPlaceCategory[] = [
  { label: "Bike Shops", emptyLabel: "Where to get parts or a tune-up?", icon: "bike-shop", types: ["bike-shop"] },
  {
    label: "Eats & Drinks",
    emptyLabel: "Best post-ride beer and burger?",
    icon: "restaurant",
    types: ["restaurant", "cafe", "bar"],
  },
  {
    label: "Places to Stay",
    emptyLabel: "Where to crash for the night?",
    icon: "accommodation",
    types: ["accommodation"],
  },
  { label: "Other spots", emptyLabel: "Anything else riders should know?", icon: "map-pin", types: null },
];

interface BikeParkRelatedSectionProps {
  placeId: string;
  relatedPlaces: RelatedPlace[];
  canEdit?: boolean;
  onRemove?: (relatedPlaceId: string) => Promise<void>;
  onSelect?: (place: RelatedPlace) => void;
}

export function BikeParkRelatedSection(props: BikeParkRelatedSectionProps) {
  const trails = props.relatedPlaces.filter(isMtbTrailRelatedPlace);
  const nearby = props.relatedPlaces.filter((p) => !isMtbTrailRelatedPlace(p));

  return (
    <>
      <TrailsSection
        placeId={props.placeId}
        trails={trails}
        canEdit={props.canEdit}
        onRemove={props.onRemove}
        onSelect={props.onSelect}
      />
      <RelatedPlacesSection {...props} title="Nearby" categories={NEARBY_CATEGORIES} relatedPlaces={nearby} />
    </>
  );
}
